var Guidance = /** @class */ (function () {
    function Guidance() {
        this.hiddenContactsFields = ['title', 'companyBilling'];
    }
    return Guidance;
}());
export default Guidance;
